<div class="form-group">
  <div class="row fields-group">
    <div class="col">
      <label class="input-label">{{ 'Grid Event' | translate }}</label>
      <select name="gridEventName" [(ngModel)]="gridEventName" (change)="gridEventNameChanged()" class="form-control">
        <option value="" selected disabled>{{ 'Choose here' | translate }}</option>
        <option *ngFor="let event of gridEvents" [value]="event.key">{{ event.name }}</option>
      </select>
    </div>
  </div>
</div>
